import type ISimpleDialogProps from '../../../utils/ISimpleDialogProps.ts';
import type { ScenarioDto } from '@/api-gen/api.schemas';

export interface ScenarioSettingsComponentProps extends ISimpleDialogProps {
  scenarioId?: ScenarioDto['id'];
}

export type CompanyDto = {
  id: number;
  name: string;
  // Extend as needed for your Company object
};

export const enum ScenarioSettingsLanguageVals {
  English = 'en-US',
  Norwegian = 'nb-NO',
  Danish = 'da-DK',
  German = 'de-DE',
  Dutch = 'nl-NL',
  Icelandic = 'is-IS',
  EnglishUk = 'en-GB',
  EnglishAustralia = 'en-AU',
  Swedish = 'sv-SE',
  SpanishSpain = 'es-ES',
  SpanishMexico = 'es-MX',
  SpanishUS = 'es-US',
  ArabicUae = 'ar-AE',
  Hindi = 'hi-IN',
  Italian = 'it-IT',
  French = 'fr-FR'
}
